// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rJCCH","newExpiryDate":"styles_newExpiryDate__1WgTw","footer":"styles_footer__2-MMw"};